import * as React from 'react';
import { ActiveFilter } from './ActiveFilter';
import { ColumnFilter } from './ColumnFilter';
import { ComponentProps } from '../DataTable';

export interface FilterProps extends ComponentProps {
    /**
     * Handler for when the filter input changes
     */
    onFilterChange?: (filterText: string) => void;
    /**
     * Handler for when the show active only checkbox changes
     */
    onActiveChange?: (checked: boolean) => void;
    /**
     * True to show the column filter (text box)
     */
    showColumnFilter: boolean;
    /**
     * True to show the active checkbox
     */
    showActiveFilter: boolean;
    /**
     * The name of the column to filter on
     */
    filterColumnName?: string;
    /**
     * The text of the filter input (this state resides in the DataTable component)
     */
    filterText: string;
    /**
     * Whether we're showing only active records
     * (this state resides in the DataTable component)
     */
    showActiveOnly: boolean;
}

/**
 * This is the Filter component
 * @param props Component props
 */
export function Filter(props: FilterProps) {
    return (
        <div className="simple-data-table-filter">
            {props.showColumnFilter && (
                <ColumnFilter
                    idSuffix={props.idSuffix}
                    columnName={
                        props.filterColumnName ? props.filterColumnName : ''
                    }
                    key={'columnFilter' + props.idSuffix}
                    onChange={(filterText: string) =>
                        props.onFilterChange(filterText)
                    }
                    filterText={props.filterText}
                />
            )}
            {props.showActiveFilter && (
                <ActiveFilter
                    idSuffix={props.idSuffix}
                    key={'activeFilter' + props.idSuffix}
                    onChange={(checked: boolean) => props.onActiveChange(checked)}
                    showActiveOnly={props.showActiveOnly}
                />
            )}
        </div>
    );
}
